import { __decorate } from 'tslib';
import { ViewContainerRef, Input, Directive, TemplateRef, EventEmitter, Output, ContentChildren, ContentChild, HostBinding, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { startWith, switchMap, mergeAll, map } from 'rxjs/operators';
import Split from 'split.js';

import * as ɵngcc0 from '@angular/core';

const _c0 = [[["", "splitPane", ""]]];
const _c1 = ["[splitPane]"];
let SplitPaneDirective = class SplitPaneDirective {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
        this.splitRatio = 1;
        this.minSize = 100;
        this.sizeChanges = new Subject();
        this.minSizeChanges = new Subject();
    }
    ngOnChanges(changes) {
        if (changes.splitRatio) {
            this.sizeChanges.next();
        }
        if (changes.minSize) {
            this.minSizeChanges.next();
        }
    }
};
SplitPaneDirective.ɵfac = function SplitPaneDirective_Factory(t) { return new (t || SplitPaneDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
SplitPaneDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SplitPaneDirective, selectors: [["", "splitPane", ""]], inputs: { splitRatio: "splitRatio", minSize: "minSize" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
SplitPaneDirective.ctorParameters = () => [
    { type: ViewContainerRef }
];
__decorate([
    Input()
], SplitPaneDirective.prototype, "splitRatio", void 0);
__decorate([
    Input()
], SplitPaneDirective.prototype, "minSize", void 0);
let SplitViewGutterDirective = class SplitViewGutterDirective {
    constructor(template) {
        this.template = template;
    }
};
SplitViewGutterDirective.ɵfac = function SplitViewGutterDirective_Factory(t) { return new (t || SplitViewGutterDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
SplitViewGutterDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SplitViewGutterDirective, selectors: [["", "gutterTemplate", ""]] });
SplitViewGutterDirective.ctorParameters = () => [
    { type: TemplateRef }
];
let SplitViewComponent = class SplitViewComponent {
    constructor(viewContainerRef) {
        this.viewContainerRef = viewContainerRef;
        this.dragging = new EventEmitter();
        this.dragStart = new EventEmitter();
        this.dragEnd = new EventEmitter();
        this.expandToMin = false;
        this.gutterSize = 10;
        this.gutterAlign = 'center';
        this.snapOffset = 30;
        this.dragInterval = 1;
        this.direction = 'horizontal';
        this.subscriptions = new Subscription();
    }
    get isHorizontal() { return this.direction === 'horizontal'; }
    get isVertical() { return this.direction === 'vertical'; }
    ngOnChanges(changes) {
        if (changes.direction ||
            changes.gutterSize ||
            changes.gutterAlign ||
            changes.snapOffset ||
            changes.dragInterval ||
            changes.expandToMin) {
            this.refresh();
        }
    }
    ngAfterContentInit() {
        const splitPaneChanges = this.splitPanes.changes
            .pipe(startWith(this.splitPanes));
        const childrenChanges = splitPaneChanges
            .subscribe(() => this.refresh());
        const sizeChanges = splitPaneChanges
            .pipe(switchMap(() => this.splitPanes.map(p => p.sizeChanges)), mergeAll())
            .subscribe(() => { var _a; return (_a = this.split) === null || _a === void 0 ? void 0 : _a.setSizes(this.getSizes()); });
        const dragEndEvents = this.dragEnd
            .pipe(map(event => event.sizes))
            .subscribe(sizes => {
            const panes = this.splitPanes.toArray();
            for (let i = 0; i < panes.length; i++) {
                panes[i].splitRatio = sizes[i];
            }
        });
        this.subscriptions.add(childrenChanges);
        this.subscriptions.add(sizeChanges);
        this.subscriptions.add(dragEndEvents);
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        this.destroySplit();
    }
    refresh() {
        this.destroySplit();
        if (!this.splitPanes || this.splitPanes.length === 0) {
            return;
        }
        const panes = new Array();
        const minSizes = new Array();
        this.splitPanes.forEach(d => {
            panes.push(d.viewContainerRef.element.nativeElement);
            minSizes.push(d.minSize);
        });
        const splitOptions = {
            sizes: this.getSizes(),
            minSize: minSizes,
            expandToMin: this.expandToMin,
            gutterSize: this.gutterSize,
            gutterAlign: this.gutterAlign,
            snapOffset: this.snapOffset,
            dragInterval: this.dragInterval,
            direction: this.direction,
            elementStyle: (dimension, size, gutterSize) => ({
                flexBasis: 'calc(' + size + '% - ' + gutterSize + 'px)'
            }),
            gutterStyle: (dimension, gutterSize) => ({
                flexBasis: gutterSize + 'px'
            }),
            onDrag: (sizes) => {
                if (this.dragging.observers.length > 0) {
                    this.dragging.emit({ source: this, sizes });
                }
            },
            onDragStart: (sizes) => this.dragStart.emit({ source: this, sizes }),
            onDragEnd: (sizes) => this.dragEnd.emit({ source: this, sizes })
        };
        if (this.gutterDef) {
            splitOptions.gutter = (index, direction) => {
                const view = this.viewContainerRef.createEmbeddedView(this.gutterDef.template);
                const elements = view.rootNodes.filter(e => e instanceof HTMLElement);
                if (elements.length !== 1) {
                    throw new Error('Gutter template must contain exactly one element');
                }
                return elements[0];
            };
        }
        this.split = Split(panes, splitOptions);
    }
    destroySplit() {
        if (!this.split) {
            return;
        }
        this.viewContainerRef.clear();
        this.split.destroy(false, !!this.gutterDef);
        this.split = undefined;
    }
    getSizes() {
        const panes = new Array();
        const ratios = new Array();
        let totalSize = 0;
        this.splitPanes.forEach(d => {
            panes.push(d.viewContainerRef.element.nativeElement);
            const sanitizedSize = d.splitRatio >= 0 ? d.splitRatio : 0;
            ratios.push(sanitizedSize);
            totalSize += sanitizedSize;
        });
        return ratios.map(size => (size / totalSize) * 100);
    }
};
SplitViewComponent.ɵfac = function SplitViewComponent_Factory(t) { return new (t || SplitViewComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef)); };
SplitViewComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SplitViewComponent, selectors: [["split-view"]], contentQueries: function SplitViewComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, SplitViewGutterDirective, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, SplitPaneDirective, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.gutterDef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.splitPanes = _t);
    } }, hostVars: 4, hostBindings: function SplitViewComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("split-view-horizontal", ctx.isHorizontal)("split-view-vertical", ctx.isVertical);
    } }, inputs: { expandToMin: "expandToMin", gutterSize: "gutterSize", gutterAlign: "gutterAlign", snapOffset: "snapOffset", dragInterval: "dragInterval", direction: "direction" }, outputs: { dragging: "dragging", dragStart: "dragStart", dragEnd: "dragEnd" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c1, decls: 1, vars: 0, template: function SplitViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c0);
        ɵngcc0.ɵɵprojection(0);
    } }, styles: ["[_nghost-%COMP%]{display:flex}.split-view-horizontal[_nghost-%COMP%]{flex-direction:row}.split-view-vertical[_nghost-%COMP%]{flex-direction:column}  .gutter.gutter-horizontal{cursor:col-resize}  .gutter.gutter-vertical{cursor:row-resize}"], changeDetection: 0 });
SplitViewComponent.ctorParameters = () => [
    { type: ViewContainerRef }
];
__decorate([
    Output()
], SplitViewComponent.prototype, "dragging", void 0);
__decorate([
    Output()
], SplitViewComponent.prototype, "dragStart", void 0);
__decorate([
    Output()
], SplitViewComponent.prototype, "dragEnd", void 0);
__decorate([
    Input()
], SplitViewComponent.prototype, "expandToMin", void 0);
__decorate([
    Input()
], SplitViewComponent.prototype, "gutterSize", void 0);
__decorate([
    Input()
], SplitViewComponent.prototype, "gutterAlign", void 0);
__decorate([
    Input()
], SplitViewComponent.prototype, "snapOffset", void 0);
__decorate([
    Input()
], SplitViewComponent.prototype, "dragInterval", void 0);
__decorate([
    Input()
], SplitViewComponent.prototype, "direction", void 0);
__decorate([
    ContentChildren(SplitPaneDirective)
], SplitViewComponent.prototype, "splitPanes", void 0);
__decorate([
    ContentChild(SplitViewGutterDirective, { static: true })
], SplitViewComponent.prototype, "gutterDef", void 0);
__decorate([
    HostBinding('class.split-view-horizontal')
], SplitViewComponent.prototype, "isHorizontal", null);
__decorate([
    HostBinding('class.split-view-vertical')
], SplitViewComponent.prototype, "isVertical", null);

let SplitViewModule = class SplitViewModule {
};
SplitViewModule.ɵfac = function SplitViewModule_Factory(t) { return new (t || SplitViewModule)(); };
SplitViewModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SplitViewModule });
SplitViewModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SplitPaneDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line: directive-selector
                selector: '[splitPane]'
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, { splitRatio: [{
            type: Input
        }], minSize: [{
            type: Input
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SplitViewGutterDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line: directive-selector
                selector: '[gutterTemplate]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SplitViewComponent, [{
        type: Component,
        args: [{
                // tslint:disable-next-line: component-selector
                selector: 'split-view',
                template: '<ng-content select="[splitPane]"></ng-content>',
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:flex}:host.split-view-horizontal{flex-direction:row}:host.split-view-vertical{flex-direction:column}::ng-deep .gutter.gutter-horizontal{cursor:col-resize}::ng-deep .gutter.gutter-vertical{cursor:row-resize}"]
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }]; }, { dragging: [{
            type: Output
        }], dragStart: [{
            type: Output
        }], dragEnd: [{
            type: Output
        }], expandToMin: [{
            type: Input
        }], gutterSize: [{
            type: Input
        }], gutterAlign: [{
            type: Input
        }], snapOffset: [{
            type: Input
        }], dragInterval: [{
            type: Input
        }], direction: [{
            type: Input
        }], isHorizontal: [{
            type: HostBinding,
            args: ['class.split-view-horizontal']
        }], isVertical: [{
            type: HostBinding,
            args: ['class.split-view-vertical']
        }], splitPanes: [{
            type: ContentChildren,
            args: [SplitPaneDirective]
        }], gutterDef: [{
            type: ContentChild,
            args: [SplitViewGutterDirective, { static: true }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SplitViewModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    SplitPaneDirective,
                    SplitViewGutterDirective,
                    SplitViewComponent
                ],
                exports: [
                    SplitPaneDirective,
                    SplitViewGutterDirective,
                    SplitViewComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SplitViewModule, { declarations: [SplitPaneDirective, SplitViewGutterDirective, SplitViewComponent], exports: [SplitPaneDirective, SplitViewGutterDirective, SplitViewComponent] }); })();

/*
 * Public API Surface of ngx-split-view
 */

/**
 * Generated bundle index. Do not edit.
 */

export { SplitPaneDirective, SplitViewComponent, SplitViewGutterDirective, SplitViewModule };

